export default {
  // fonts: {
  //   url: null
  // },
  colors: {
    primary: null,
    secondary: null
  }
};
